{
  "AGENT_BOTS": {
    "HEADER": "ربات‌ها",
    "LOADING_EDITOR": "در حال بارگیری ویرایشگر...",
    "DESCRIPTION": "ربات‌های عامل مانند شگفت‌انگیزترین اعضای تیم شما هستند. آن‌ها می‌توانند کارهای کوچک را انجام دهند، بنابراین شما می‌توانید روی چیزهای مهم تمرکز کنید. آن‌ها را امتحان کنید. می‌توانید ربات‌های خود را از این صفحه مدیریت کنید یا با استفاده از دکمه «افزودن ربات»، ربات‌های جدیدی ایجاد کنید.",
    "LEARN_MORE": "Learn about agent bots",
    "COUNT": "{n} bot | {n} bots",
    "SEARCH_PLACEHOLDER": "Search bots...",
    "NO_RESULTS": "No bots found matching your search",
    "GLOBAL_BOT": "ربات سیستمی",
    "GLOBAL_BOT_BADGE": "سیستم",
    "AVATAR": {
      "SUCCESS_DELETE": "آواتار ربات با موفقیت حذف شد",
      "ERROR_DELETE": "خطا هنگام حذف آواتار ربات، لطفا مجدد امتحان کنید"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "انتخاب یک ربات عامل",
      "DESC": "یک ربات به صندوق ورودی خود اختصاص دهید. ربات‌ها می توانند مکالمات اولیه را انجام دهند و در صورت لزوم آنها را به یک اپراتور منتقل کنند.",
      "SUBMIT": "اعمال شود",
      "DISCONNECT": "قطع ربات",
      "SUCCESS_MESSAGE": "ربات عامل با موفقیت به‌روز شد.",
      "DISCONNECTED_SUCCESS_MESSAGE": "ربات عامل با موفقیت قطع شد.",
      "ERROR_MESSAGE": "ربات عامل به‌روزرسانی نشد، لطفا دوباره امتحان کنید.",
      "DISCONNECTED_ERROR_MESSAGE": "ربات قطع نشد، لطفا بعدا دوباره امتحان کنید.",
      "SELECT_PLACEHOLDER": "انتخاب ربات"
    },
    "ADD": {
      "TITLE": "افزودن ربات",
      "CANCEL_BUTTON_TEXT": "انصراف",
      "API": {
        "SUCCESS_MESSAGE": "ربات با موفقیت اضافه شد.",
        "ERROR_MESSAGE": "ربات اضافه نشد، لطفا بعدا دوباره امتحان کنید."
      }
    },
    "LIST": {
      "404": "هیچ رباتی یافت نشد. شما می‌توانید با کلیک روی دکمه «افزودن ربات» یک ربات ایجاد کنید.",
      "LOADING": "در حال گرفتن ربات‌ها...",
      "TABLE_HEADER": {
        "DETAILS": "جزئیات ربات",
        "URL": "آدرس URL وب هوک",
        "ACTIONS": "عملیات"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "حذف",
      "TITLE": "حذف ربات",
      "CONFIRM": {
        "TITLE": "تاییدیه حذف",
        "MESSAGE": "آیا مطمئنید که می‌خواهید {name} را حذف کنید؟",
        "YES": "بله، حذف شود",
        "NO": "نه، بماند"
      },
      "API": {
        "SUCCESS_MESSAGE": "ربات با موفقیت حذف شد.",
        "ERROR_MESSAGE": "ربات حذف نشد، لطفا دوباره امتحان کنید."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "ویرایش",
      "TITLE": "ویرایش ربات",
      "API": {
        "SUCCESS_MESSAGE": "ربات با موفقیت به‌روز شد.",
        "ERROR_MESSAGE": "ربات بروز رسانی نشد، لطفا دوباره امتحان کنید."
      }
    },
    "SECRET": {
      "LABEL": "Webhook Secret",
      "COPY": "Copy secret to clipboard",
      "COPY_SUCCESS": "Secret copied to clipboard",
      "TOGGLE": "Toggle secret visibility",
      "CREATED_DESC": "Use the secret below to verify webhook signatures. Please copy it now, you can also find it later in the bot settings.",
      "DONE": "Done",
      "RESET_SUCCESS": "Webhook secret regenerated successfully",
      "RESET_ERROR": "Unable to regenerate webhook secret. Please try again"
    },
    "ACCESS_TOKEN": {
      "TITLE": "توکن دسترسی",
      "DESCRIPTION": "توکن دسترسی را کپی کرده و در جای امن ذخیره کنید",
      "COPY_SUCCESSFUL": "توکن دسترسی در کلیپبورد کپی شد",
      "RESET_SUCCESS": "توکن دسترسی با موفقیت بازسازی شد",
      "RESET_ERROR": "خطا در بازسازی توکن دسترسی. لطفا مجدد امتحان کنید"
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "آواتار ربات"
      },
      "NAME": {
        "LABEL": "نام ربات",
        "PLACEHOLDER": "نام ربات را وارد کنید",
        "REQUIRED": "نام ربات الزامی است"
      },
      "DESCRIPTION": {
        "LABEL": "توضیحات",
        "PLACEHOLDER": "این ربات چه کاری انجام می‌دهد؟"
      },
      "WEBHOOK_URL": {
        "LABEL": "آدرس URL وب هوک",
        "PLACEHOLDER": "https://example.com/webhook",
        "REQUIRED": "URL وب‌هوک الزامی است"
      },
      "ERRORS": {
        "NAME": "نام ربات الزامی است",
        "URL": "URL وب‌هوک الزامی است",
        "VALID_URL": "لطفا یک URL معتبر که با http:// یا https:// شروع می‌شود وارد کنید"
      },
      "CANCEL": "انصراف",
      "CREATE": "ایجاد ربات",
      "UPDATE": "به‌روزرسانی ربات"
    },
    "WEBHOOK": {
      "DESCRIPTION": "یک ربات وب‌هوک برای ادغام با سرویس‌های سفارشی‌تان پیکربندی کنید. این ربات رویدادها را از مکالمات دریافت کرده و پردازش می‌کند و می‌تواند به آن‌ها پاسخ دهد."
    },
    "TYPES": {
      "WEBHOOK": "وب‌هوک ربات"
    }
  }
}
